var _style, _path, _defs, _g, _path2, _g2, _g3, _circle, _rect, _rect2, _path3, _path4, _g4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F5DAB;}\n\t.st1{clip-path:url(#SVGID_00000167378501420393951040000007925532230179554949_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000167378501420393951040000007925532230179554949_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000167378501420393951040000007925532230179554949_);fill:none;}\n\t.st5{fill:#936145;}\n\t.st6{fill:#B4D0BF;}\n\t.st7{fill:#FFD5C0;}\n\t.st8{fill:#F2C3AF;}\n\t.st9{fill:#3D3D3D;}\n\t.st10{fill:#263951;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072245302710660276430000002396811890235613313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072245302710660276430000002396811890235613313_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.6,158.4c-0.4,1.2-0.8,2.2-1.3,3.4h61.7c-0.4-1.2-0.8-2.2-1.3-3.4c-5.4-15.1-1.3-57,4.2-75.7 c5-16.9-33.4-20.4-33.4-20.4s-40.2,3.6-35.2,20.4C25.1,101.4,29.9,143.2,24.6,158.4z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072245302710660276430000002396811890235613313_)",
      fill: "#FFFFFF"
    },
    d: "M101.3,93.4l-19.6,12.4 L66.2,90.9L75.6,67c0,0,10.7,4.1,14.4,8.8C93.7,80.4,101.3,93.4,101.3,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072245302710660276430000002396811890235613313_)",
      fill: "#FFFFFF"
    },
    d: "M7.4,93.4l19.6,12.4 l15.5-14.9L33.2,67c0,0-10.7,4.1-14.4,8.8C15.1,80.4,7.4,93.4,7.4,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072245302710660276430000002396811890235613313_)",
      fill: "none"
    },
    d: "M134.5,101 c0,0-0.1,0-0.2,0.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.1,63c0,0,2.3,6.8,9.3,6.8c7.2,0,8.8-6.8,8.8-6.8c-1.2-3.8-2-9-1.3-15.5c0.2-1.7-4-3.1-6.7-3.8l0.1-0.6 c0,0-0.5,0.1-1.3,0.3c-0.8-0.2-1.3-0.3-1.3-0.3l0.1,0.6c-2.7,0.8-6.9,2.2-6.7,3.8C49.1,54,48.3,59.1,47.1,63z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.6,61.3L47.6,61.3c0,0.6,0,1.1,0,1.5c-5.3,1.8-9.2,6.8-9.2,12.8v2.8c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7v-2.8C36.9,68.8,41.4,63.1,47.6,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.3,75.6v5.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-5.7c0-5.9-3.9-11-9.2-12.8c0-0.5,0-1,0-1.4 v-0.1C70.8,63.1,75.3,68.8,75.3,75.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.6,89.4c-0.3,0-0.6-0.2-0.6-0.6v-3.3c0-3.4-2.7-6.1-6.1-6.1h-4.5c-3.4,0-6.1,2.7-6.1,6.1v3.3 c0,0.3-0.2,0.6-0.6,0.6s-0.6-0.2-0.6-0.6v-3.3c0-4,3.2-7.2,7.2-7.2h4.5c4,0,7.2,3.2,7.2,7.2v3.3C47.2,89.1,46.9,89.4,46.6,89.4z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 74.6,
    cy: 85,
    r: 4.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.6,
    y: 88.3,
    className: "st6",
    width: 2.4,
    height: 2.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 88.3,
    className: "st6",
    width: 2.4,
    height: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.5,45.1c0,0.8,0.3,1.5-0.6,1.5h-0.5c-0.8,0-1.7-5.2-1.7-8.9c0-0.8,0.4-1.5,1.3-1.5l0,0 c0.8,0,0.8,0.7,0.8,1.5L42.5,45.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M69.9,45.1c0,0.8,0,1.5,0.8,1.5H71c0.8,0,1.7-5.4,1.7-8.9c0-0.8-0.4-1.5-1.3-1.5l0,0c-0.8,0-0.8,0.7-0.8,1.5 L69.9,45.1z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M47.1,63c0,0,2.3,6.8,9.3,6.8c7.2,0,8.8-6.8,8.8-6.8c-1.2-3.8-2-9-1.3-15.5c0.2-1.7-4-3.1-6.7-3.8l0.1-0.6 c0,0-0.5,0.1-1.3,0.3c-0.8-0.2-1.3-0.3-1.3-0.3l0.1,0.6c-2.7,0.8-6.9,2.2-6.7,3.8C49.1,54,48.3,59.1,47.1,63z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "47.1,63 56.3,81.9 65.3,63 53.6,64.6  "
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.5,18.5c-8.2,0-14.9,7.2-14.9,16.1v7.5C41.6,51,45.2,63,56.5,63s14.9-12,14.9-20.8v-7.5 C71.4,25.7,64.7,18.5,56.5,18.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.2,40.7c0,0,1.3-3.7,3.4-3.8c2.9-0.1,5.6-2,11.9-5.2c0,0,14.7,4.8,15,8.8c0,0,11.4-26.3-14.1-26.3 C33.2,14.2,38.7,34.3,41.2,40.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M39.8,42.3l3.9-3.8l0.5,0.8l12.2-7.6l-1.8-17.3c0,0-3.8-1.8-7,0.1c-3.3,1.9-9.6,5.6-9.5,12.7 S36.9,36.7,39.8,42.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M53.2,14.4c0,0,5.8-1.9,9.7-0.6s9,3.1,10.5,8.6s-0.7,19.1-1,19.7c0,0-5.1-6.9-16.1-10.4L53.2,14.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.cb65623aa4ca569104bf8e3256ed1ce6.svg";
export { ForwardRef as ReactComponent };